/* tslint:disable */
/* eslint-disable */
/**
 * Corrigo API
 * fejlesztői
 *
 * The version of the OpenAPI document: 1.5.2
 * Contact: kerezsigergely@infobex.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class LoginsApi extends runtime.BaseAPI {
    /**
     * Hozzáférések keresése metaadat alapján
     *  [ID: FindLogins]
     */
    findLoginsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['approximate'] != null) {
                queryParameters['approximate'] = requestParameters['approximate'];
            }
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/find`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['SearchParameter'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Hozzáférések keresése metaadat alapján
     *  [ID: FindLogins]
     */
    findLogins() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.findLoginsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * RTK hozzáférések lekérdezése [ID: GetLogin]
     */
    getLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling getLogin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/{login_id}`.replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * RTK hozzáférések lekérdezése [ID: GetLogin]
     */
    getLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * RTK hozzáférések listázása [ID: GetLogins]
     */
    getLoginsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['with_metadata'] == null) {
                throw new runtime.RequiredError('with_metadata', 'Required parameter "with_metadata" was null or undefined when calling getLogins().');
            }
            if (requestParameters['with_subscriptions'] == null) {
                throw new runtime.RequiredError('with_subscriptions', 'Required parameter "with_subscriptions" was null or undefined when calling getLogins().');
            }
            const queryParameters = {};
            if (requestParameters['with_metadata'] != null) {
                queryParameters['with_metadata'] = requestParameters['with_metadata'];
            }
            if (requestParameters['with_subscriptions'] != null) {
                queryParameters['with_subscriptions'] = requestParameters['with_subscriptions'];
            }
            if (requestParameters['last_login'] != null) {
                queryParameters['last_login'] = requestParameters['last_login'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * RTK hozzáférések listázása [ID: GetLogins]
     */
    getLogins(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLoginsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetLoginsByUserId]
     */
    getLoginsByUserIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['user_id'] == null) {
                throw new runtime.RequiredError('user_id', 'Required parameter "user_id" was null or undefined when calling getLoginsByUserId().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/{user_id}/logins`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['user_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetLoginsByUserId]
     */
    getLoginsByUserId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLoginsByUserIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Hozzáféréshez tartozó előfizetések lekérdezése [ID: GetSubscriptionsByLogin]
     * @deprecated
     */
    getSubscriptionsByLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling getSubscriptionsByLogin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/{login_id}/subscriptions`.replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Hozzáféréshez tartozó előfizetések lekérdezése [ID: GetSubscriptionsByLogin]
     * @deprecated
     */
    getSubscriptionsByLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubscriptionsByLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Hozzáférés zárolása [ID: LockLogin]
     */
    lockLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling lockLogin().');
            }
            if (requestParameters['LockLoginRequest'] == null) {
                throw new runtime.RequiredError('LockLoginRequest', 'Required parameter "LockLoginRequest" was null or undefined when calling lockLogin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/{login_id}/lock`.replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['LockLoginRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Hozzáférés zárolása [ID: LockLogin]
     */
    lockLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lockLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Hozzáférés átnevezése [ID: RenameLogin]
     */
    renameLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling renameLogin().');
            }
            if (requestParameters['RenameLoginRequest'] == null) {
                throw new runtime.RequiredError('RenameLoginRequest', 'Required parameter "RenameLoginRequest" was null or undefined when calling renameLogin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/{login_id}/`.replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['RenameLoginRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Hozzáférés átnevezése [ID: RenameLogin]
     */
    renameLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.renameLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Hozzáférés jelszó módosítása [ID: ResetLoginPassword]
     */
    resetLoginPasswordRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling resetLoginPassword().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/{login_id}/auth`.replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Hozzáférés jelszó módosítása [ID: ResetLoginPassword]
     */
    resetLoginPassword(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.resetLoginPasswordRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: TransferLogin]
     */
    transferLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['user_id'] == null) {
                throw new runtime.RequiredError('user_id', 'Required parameter "user_id" was null or undefined when calling transferLogin().');
            }
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling transferLogin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/{user_id}/logins/{login_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['user_id']))).replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: TransferLogin]
     */
    transferLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.transferLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Hozzáférés feloldása [ID: UnlockLogin]
     */
    unlockLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling unlockLogin().');
            }
            if (requestParameters['UnlockLoginRequest'] == null) {
                throw new runtime.RequiredError('UnlockLoginRequest', 'Required parameter "UnlockLoginRequest" was null or undefined when calling unlockLogin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/{login_id}/unlock`.replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['UnlockLoginRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Hozzáférés feloldása [ID: UnlockLogin]
     */
    unlockLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unlockLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Hozzáférés jelszó tesztelése [ID: ValidateLogin]
     */
    validateLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling validateLogin().');
            }
            if (requestParameters['ValidateLoginRequest'] == null) {
                throw new runtime.RequiredError('ValidateLoginRequest', 'Required parameter "ValidateLoginRequest" was null or undefined when calling validateLogin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/{login_id}/auth`.replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['ValidateLoginRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Hozzáférés jelszó tesztelése [ID: ValidateLogin]
     */
    validateLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.validateLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
